import React from 'react';

import scrollIntoView from 'scroll-into-view';

export const scrollTo = (section, callback) => {
  const node = document.querySelector(`div[data-section='${section}']`);

  if (node) {
    scrollIntoView(node, { time: 500, align: { top: 0.1 } }, () => {
      // done
      // callback();
    });

    if (callback) {
      callback();
    }
  }
};

export const SECTIONS = {
  FUTEURE_COMMING: 'FUTEURE_COMMING',
  HISTORY_PROGRESS: 'HISTORY_PROGRESS',
  HISTORY_MAP: 'HISTORY_MAP',
  TECHNOLOGIES: 'TECHNOLOGIES',
  SPEED: 'SPEED',
  INTERVIEW: 'INTERVIEW',

  TECHNOLOGIES_MAP: 'TECHNOLOGIES_MAP',
  TECHNOLOGIES_DESCRIPTION: 'TECHNOLOGIES_DESCRIPTION',
};

export default props => <div data-section={props.section} />;
